import APIService from "@quest-finance/quest-fe-shared/dist/common/services/APIService";
import { ListResponse } from "@quest-finance/quest-fe-shared/dist/common/types/ListResponse";
import { SingleResponse } from "@quest-finance/quest-fe-shared/dist/common/types/SingleResponse";
import { Method } from "axios";
import queryString from "query-string";
import { RoleForm } from "../types/RoleForm";
import { RoleListRequest } from "../types/RoleListRequest";
import { RoleResponse } from "../types/RoleResponse";

class RoleService {
  public static async getRoleList(
    payload?: RoleListRequest
  ): Promise<ListResponse<RoleResponse>> {
    const queryParams = payload
      ? queryString.stringify(payload, {
          skipNull: true,
          skipEmptyString: true,
        })
      : "";
    const method: Method = "GET";
    const path = `/iam/roles?${queryParams}`;

    const result = await APIService.jsonRequest<
      ListResponse<RoleResponse>,
      unknown
    >(
      {
        method,
        path,
      },
      true
    );
    return result;
  }

  public static async getDetails(
    roleId: number
  ): Promise<SingleResponse<RoleResponse>> {
    const result = await APIService.jsonRequest<
      SingleResponse<RoleResponse>,
      unknown
    >(
      {
        method: "GET",
        path: `/iam/roles/${roleId}`,
      },
      true
    );
    return result;
  }

  public static async create(
    data: RoleForm
  ): Promise<SingleResponse<RoleResponse>> {
    const result = await APIService.jsonRequest<
      SingleResponse<RoleResponse>,
      RoleForm
    >(
      {
        method: "POST",
        path: `/iam/roles`,
        data,
      },
      true
    );
    return result;
  }

  public static async update(
    roleId: number,
    data: RoleForm
  ): Promise<SingleResponse<RoleResponse>> {
    const result = await APIService.jsonRequest<
      SingleResponse<RoleResponse>,
      RoleForm
    >(
      {
        method: "PUT",
        path: `/iam/roles/${roleId}`,
        data,
      },
      true
    );
    return result;
  }
}

export default RoleService;
